import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer className="portfolio-footer">
      <div className="footer-social-icons">
        <a href="https://github.com/rahul-r-joshua" target="_blank" rel="noreferrer" aria-label="GitHub"><GitHubIcon/></a>
        <a href="https://www.linkedin.com/in/rahul-ramasamy-in/" target="_blank" rel="noreferrer" aria-label="LinkedIn"><LinkedInIcon/></a>
      </div>
      <p className="footer-copy">
        Designed & Built by <strong>Rahul Ramasamy</strong> | Robotics & Automation Engineer
      </p>
    </footer>
  );
}

export default Footer;